import React, { Suspense, useEffect } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';
import Navigation from './components/Navigation';
import Footer from './components/Footer';
import ReadingProgress from './components/ReadingProgress';
import LoadingSpinner from './components/LoadingSpinner';
import ScrollToTop from './components/ScrollToTop';
import ScrollToTopButton from './components/ScrollToTopButton';
import ErrorBoundary from './components/ErrorBoundary';
import { setupSmoothScroll } from './utils/smoothScroll';

// Lazy load pages with explicit default exports
const Home = React.lazy(() => import('./pages/Home'));
const Books = React.lazy(() => import('./pages/Books'));
const BookCancun = React.lazy(() => import('./pages/BookCancun'));
const BookTresor = React.lazy(() => import('./pages/BookTresor'));
const BookTresorTome1 = React.lazy(() => import('./pages/BookTresorTome1'));
const BookTresorTome2 = React.lazy(() => import('./pages/BookTresorTome2'));
const Author = React.lazy(() => import('./pages/Author'));
const Contact = React.lazy(() => import('./pages/Contact'));
const MentionsLegales = React.lazy(() => import('./pages/MentionsLegales'));
const Confidentialite = React.lazy(() => import('./pages/Confidentialite'));
const NotFound = React.lazy(() => import('./pages/NotFound'));

const AppContent: React.FC = () => {
  const location = useLocation();

  useEffect(() => {
    // Initialiser le smooth scroll pour Brave et autres navigateurs
    setupSmoothScroll();
  }, []);

  return (
    <div className="min-h-screen flex flex-col">
      <ScrollToTop />
      <ReadingProgress />
      <Navigation />
      <main className="flex-grow">
        <AnimatePresence mode="wait">
          <Suspense fallback={<LoadingSpinner />}>
            <Routes location={location} key={location.pathname}>
              <Route path="/" element={<Home />} />
              <Route path="/books" element={<Books />} />
              <Route path="/book/cancun" element={<BookCancun />} />
              <Route path="/book/tresor" element={<BookTresor />} />
              <Route path="/book/tresor/tome1" element={<BookTresorTome1 />} />
              <Route path="/book/tresor/tome2" element={<BookTresorTome2 />} />
              <Route path="/author" element={<Author />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/mentions-legales" element={<MentionsLegales />} />
              <Route path="/confidentialite" element={<Confidentialite />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </Suspense>
        </AnimatePresence>
      </main>
      <ScrollToTopButton />
      <Footer />
    </div>
  );
};

const App: React.FC = () => {
  return (
    <ErrorBoundary>
      <AppContent />
    </ErrorBoundary>
  );
};

export default App;